// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tepig: PokeData = {
  "id": 498,
  "name": "tepig",
  "height": 5,
  "weight": 99,
  "base_experience": 62,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "tail-whip",
    "roar",
    "ember",
    "flamethrower",
    "defense-curl",
    "smog",
    "endure",
    "rollout",
    "odor-sleuth",
    "assurance",
    "flare-blitz",
    "head-smash",
    "flame-charge",
    "heat-crash"
  ],
  "moves": [
    "tackle",
    "ember",
    "flamethrower",
    "flare-blitz",
    "sunny-day",
    "eruption",
    "morning-sun",
    "fire-fang",
    "fire-spin",
    "fire-ball",
    "magma-storm",
    "blaze-kick",
    "fire-punch"
  ],
  "evolution_chain": {
    "id": 257,
    "item": null,
    "species": [
      {
        "name": "tepig",
        "order": 499,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pignite",
        "order": 500,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 498,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "emboar",
        "order": 501,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 499,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 45,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
